import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {FuseMainComponent} from '../main/main.component';

import {AuthResponse} from './model/authResponse';
import {SessionService} from './services/session.service';
import {AuthService} from './services/auth.service';

@Injectable()
export class AuthDataManager {
  constructor(private authService: AuthService, private sessionService: SessionService) {}

  login(username: string, password: string, twoFactorCode?: string): Observable<AuthResponse> {
    return this.authService.login(username, password, twoFactorCode);
  }

  setupTwoFactor(): Observable<any> {
    return this.authService.setupTwoFactor();
  }

  enableTwoFactor(twoFactorCode: string): Observable<AuthResponse> {
    return this.authService.enableTwoFactor(twoFactorCode);
  }

  disableTwoFactor(twoFactorCode: string): Observable<AuthResponse> {
    return this.authService.disableTwoFactor(twoFactorCode);
  }

  isLoggedIn() {
    const token = localStorage.getItem('token');
    if (token !== '' && token !== null) {
      return true;
    }
    return false;
  }

  logout() {
    this.sessionService.clearSession();
    window.location.replace('');
  }

  clearSession() {
    this.sessionService.clearSession();
  }

  setLogin(response: AuthResponse) {
    localStorage.setItem('token', response.token);
    localStorage.setItem('refresh_token', response.refresh_token || '');
    localStorage.setItem('tokenTTL', response.tokenTTL || '');
    localStorage.setItem('requires_2fa_setup', response.requires_2fa_setup ? 'true' : 'false');
    localStorage.setItem('two_factor_enabled', response['2fa'] && response['2fa'].is_enabled ? 'true' : 'false');
    localStorage.setItem('two_factor_forced', response['2fa'] && response['2fa'].force ? 'true' : 'false');
  }

  requiresTwoFactorSetup() {
    return localStorage.getItem('requires_2fa_setup') === 'true';
  }

  isTwoFactorEnabled() {
    return localStorage.getItem('two_factor_enabled') === 'true';
  }

  isTwoFactorForced() {
    return localStorage.getItem('two_factor_forced') === 'true';
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/auth.datamanager.ts